<template>
	<el-container class="bgcolor">
		<el-aside style="width: 200px;">
			<menus></menus>
		</el-aside>
		<el-main>
			<el-header class="el-header" style="text-align: right;">
				<el-dropdown>
					<i class="el-icon-setting" style="margin-right: 15px;font-size: 27px;"></i>

					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native='editSure()'>修改密码</el-dropdown-item>
						<router-link to='/login'>
							<el-dropdown-item @click.native='exituser()'>退出登录</el-dropdown-item>
						</router-link>
					</el-dropdown-menu>
				</el-dropdown>
				<span style="font-size:16px;"> <i class="el-icon-user" style="font-size: 27px;"></i>{{username}}</span>
			</el-header>
			<RouterView></RouterView>
		</el-main>
	</el-container>
</template>

<script>
	import Vue from 'vue'
	import menus from "./mymenu.vue"
	import user from '../apifunction/User.js'
	export default {
		data() {
			return {
				username: '', //this.myglobal.UserName
				roleid: ''
			}
		},
		mounted() {

			// let user=this.$myglobal.userinfo;
			this.username = this.$myglobal.getUserInfo().username;
			// this.roleid=user.roleid;
		},
		components: {
			menus
		},

		methods: {
			onOpends(item) {
				this.$router.push(item.url)

			},
			editSure() {
				let userent = this.$myglobal.getUserInfo();
				this.$prompt('请输入新密码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					user.EditPwd(userent.id, this.CommonFun.EncryptMd5(value))
						.then(res1 => {
							var ent1 = JSON.parse(JSON.stringify(res1.data))
							if (ent1.Flag == 'success') {
								this.$message.success("修改成功！");
							} else
								this.$message.info(ent1.Msg);
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});

			},
			exituser() {
				this.$myglobal.setUserInfo([]);
				this.$router.push('login');
				this.$router.go(0)

			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0
	}

	a {
		text-decoration: none;
	}

	li {
		list-style: none;
	}

	.menus {
		background: #b3c0d1;
		height: 100%;
	}

	.el-menu {
		background: #b3c0d1;
		height: 100%;
	}

	.icon {
		font-size: 27px;
	}

	.el-container {
		height: 100%;
	}
</style>
